import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { VueClipboard } from "@soerenmartius/vue3-clipboard"; //https://www.npmjs.com/package/@soerenmartius/vue3-clipboard

// import AppConfig from "@/config/vueconfig.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import Tracking from "@/plugins/Tracking.js";
import Filter from "@/plugins/Filter.js";

import './index.css';
import "@splidejs/splide/dist/css/splide.min.css";

createApp(App)
    .use(store)
    .use(router)
    .use(Tracking)
    .use(Filter)
    .use(VueClipboard)
    .mixin(ErrorApiMixin)
    .mount('#app')

// POSTMan
// https://documenter.getpostman.com/view/3413781/UyrEgu9H#51e513e4-c8ab-43b9-b1d6-2d7673cd9aff
/*
userlevel point
curl -v \
    -X GET \
    -H "User-Agent: BURGER KING_STG/2.0.0 (com.buzzebees.BurgerKing; build:1; iOS 15.5.0) Alamofire/5.6.1" \
    -H "Accept-Language: th-US;q=1.0" \
    -H "Accept-Encoding: br;q=1.0, gzip;q=0.9, deflate;q=0.8" \
    -H "App-Id: 1351788021633457" \
    -H "Authorization: token .5jB029uB8VFLHJE3yTgt5onhI_kDuxr8SEdXutrDO_SSicmmoKkSOX9CmnC5Pxtz0xyyGvO5tGgjlBBmxF8ugtEuBtkurCM-rdWsoI7ELLRLZMCoaIqp1bRlF_Zh4p3DE_C3szEO4GHZr93hibNCebJq2_wm8YLhHPZAqD1-EIE1AQ5x13cBV0TqxvBARchFM67_M5nS1eYUPPaQ1eLPNPb1gqcFk-lV7mM6s0cL9zZZ62fArilSPJ4Zc35yh3SQ" \
    "https://stg-module-burgerking.azurewebsites.net/profile/BGK_1543855545555/level"
*/
